import React, {useEffect, useState, useRef, useCallback} from "react";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";

import "./style.scss";

import Header from "../../components/Header";
import MallStore from "../../components/SelectMallStore";
import MallStoreList from "../../components/MallStoreList";
import Button from "../../components/Button";
import Loader from "../../components/Loader";
import "../../components/Loader/style.scss";
// import {dataDashboard} from "../../util";
import {
  setCustomerSlotDetails,
  getCustomerSlotDetails,
} from "../../services/SessionStorage";
import {ADOBEDTM_PAGE_NAME} from "../../constants";

import {API, processApiResponse} from "../../services/HttpHandler";

import config from "../../../config";

const SelectMallStore = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useRef(useNavigate());
  const {t} = useTranslation();
  const [error, setError] = useState("");
  const customerSlotDetails = useRef(getCustomerSlotDetails());
  const [selectedMallStore, setSelectedMallStore] = useState(1);
  const [selectStoreMaxlimit, setSelectStoreMaxlimit] = useState(1);
  const [showMallStoreList, setShowMallStoreList] = useState(false);
  const [selectedMallStoreList, setSelectedMallStoreList] = useState([]);
  const [selectedStoreUUIDList, setSelectedStoreUUIDList] = useState([]);
  const [avlMallStoresList, setAvlMallStoresList] = useState([]);

  const avlOptions = [
    {
      text: "En el Mall",
      id: 1,
      tooltip:
        "Te permitirá hacer una reserva solo para entrar a las áreas comunes del mall",
    },
    {
      text: "En las Tiendas",
      id: 2,
      tooltip:
        "Te permitirá hacer reservas en las tiendas cuando ya estas dentro del mall sin tener que hacer una en él",
    },
    {
      text: "En las Tiendas y Mall",
      id: 3,
      tooltip:
        "Te permitirá hacer una reserva para el mall y las tiendas en él",
    },
  ];

  const handleMallStoreSelect = (option) => {
    setSelectedMallStore(option);
  };

  const handleMallStoreListSelect = (option) => {
    setSelectedMallStoreList(option);
  };

  const handleMallStoreUUIDListSelect = (option) => {
    setSelectedStoreUUIDList(option);
  };

  const handleClick = () => {
    customerSlotDetails.current.selectedType = selectedMallStore;
    customerSlotDetails.current.selectedMallStores = selectedMallStoreList;
    setCustomerSlotDetails(customerSlotDetails.current);
    navigate.current("/customer/bookSlot");
  };

  const fetchMallStoresList = useCallback(async () => {
    const storeInsideMallUrl = config.endPoints.storeInsideMall;
    const storeIdPlaceholder = /storeIdPlaceholder/gi;
    const url = storeInsideMallUrl.replace(
      storeIdPlaceholder,
      customerSlotDetails.current.currentBookingDetails.selectedStore.uuid
    );
    try {
      setLoading(true);
      let response = await API.get(url);
      response = await processApiResponse(response);
      setAvlMallStoresList(response.stores);
    } catch (error) {
      setError(t("error.failedStoreInMallStoreFetch"));
    } finally {
      setLoading(false);
    }
  }, [t]);

  useEffect(() => {
    const storeInfo = customerSlotDetails.current.storeStoreData;
    const noOfStoresAllowedMax = storeInfo
      ? storeInfo.selectedStore.noOfStoresAllowedMax
      : 0;
    setSelectStoreMaxlimit(noOfStoresAllowedMax);
    customerSlotDetails.current.currentBookingDetails =
      customerSlotDetails.current.storeStoreData;
    if (noOfStoresAllowedMax > 0) {
      fetchMallStoresList();
    } else {
      setCustomerSlotDetails(customerSlotDetails.current);
      navigate.current("/customer/bookSlot");
    }
  }, [fetchMallStoresList]);

  useEffect(() => {
    if (selectedMallStore !== 1) {
      setShowMallStoreList(true);
    } else {
      setShowMallStoreList(false);
      setSelectedMallStoreList([]);
      setSelectedStoreUUIDList([]);
    }
  }, [selectedMallStore]);

  // useEffect(() => {
  //   // for data dashboard
  //   const URL = window.location.href.split("/")[2];
  //   const officeApp = customerSlotDetails.current.isOffice
  //     ? URL + "/office"
  //     : URL + "/app";
  //   const datamap = new Map();
  //   datamap.set("pageName", ADOBEDTM_PAGE_NAME.CT_Store_in_mall_Selection);
  //   datamap.set("prop1", URL);
  //   datamap.set("prop2", officeApp);
  //   dataDashboard(datamap);
  // }, []);

  return loading ? (
    <div className="loader-container">
      <Loader />
    </div>
  ) : (
    <div className="selectMallStore-main-container1">
      <>
        <Header title={t("selectmallstore.title")} />
        <MallStore
          selectedOption={selectedMallStore}
          setSelectedOption={handleMallStoreSelect}
          avlOptions={avlOptions}
        />
        {showMallStoreList ? (
          error ? (
            <div className="booking-error">{error}</div>
          ) : (
            <MallStoreList
              selectedStore={selectedMallStoreList}
              setSelectedStore={handleMallStoreListSelect}
              avlStores={avlMallStoresList}
              maxlimit={selectStoreMaxlimit}
              selectedStoreUUIDList={selectedStoreUUIDList}
              setSelectedStoreList={handleMallStoreUUIDListSelect}
            />
          )
        ) : (
          <div></div>
        )}
        <Button value={t("proceed.label")} handleClick={handleClick} />
      </>
    </div>
  );
};

export default SelectMallStore;
